<app-main-page>
  <div *appLoading="(loading$ | async) || (machinesLoading$ | async)"></div>
  @if (!(loading$ | async) && !(machinesLoading$ | async)) {
    <form [formGroup]="issueForm" (ngSubmit)="onSubmit(model)" class="bg-white shadow-md rounded-lg px-4 pt-6 pb-8 mb-4">
      <formly-form [form]="issueForm" [fields]="fields" [options]="options" [model]="model"></formly-form>
      <app-submit-button>{{ isNew ? 'Create' : 'Save' }}</app-submit-button>
    </form>
  }
</app-main-page>
